// Which overlay is on top, for the layers that listen on `window` for Escape.
//
// The nav drawer and the search palette each bind their own window-level
// keydown. Nothing stopped them both acting on one Escape, so with the palette
// opened over the drawer a single press dismissed the drawer too — a layer the
// viewer never asked to close. A DOM check cannot settle it: the two render as
// siblings under different parents, so neither contains the other.
//
// Order of registration is the answer, and it is honest here because a layer
// registers when it mounts: the palette, opened second, is on top.

const stack: symbol[] = [];

/** Register a layer. Returns the handle to release it with. */
export function pushModalLayer(label: string): symbol {
  const id = Symbol(label);
  stack.push(id);
  return id;
}

export function popModalLayer(id: symbol): void {
  const at = stack.lastIndexOf(id);
  if (at !== -1) stack.splice(at, 1);
}

/** True when `id` is the layer a dismissal should act on. A layer that never
 *  registered is not topmost, so an unguarded caller stays inert rather than
 *  stealing the key. */
export function isTopModalLayer(id: symbol): boolean {
  return stack.length > 0 && stack[stack.length - 1] === id;
}

/** Test seam — drop every registration. */
export function resetModalStackForTests(): void {
  stack.length = 0;
}
